var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45496 9.39523C5.45496 9.54982 5.39645 9.70668 5.28234 9.82394C5.0539 10.0587 4.67617 10.0587 4.44774 9.82394L0.17316 5.43134C0.0628321 5.31796 0.000532839 5.15801 0.000532846 5.00263C0.000532852 4.8487 0.0550549 4.69529 0.17316 4.57392L4.44226 0.187318C4.66733 -0.0584259 5.05398 -0.0615797 5.28241 0.173165C5.51085 0.407909 5.51085 0.796067 5.28241 1.03081L5.28227 1.03096L1.41728 4.99478L5.28245 8.96667C5.39677 9.08415 5.45508 9.24101 5.45508 9.39538L5.45496 9.39523Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbutton);
export default __webpack_public_path__ + "static/media/Backbutton.77727f0717aeec086269168a8ffe0058.svg";
export { ForwardRef as ReactComponent };